import React, { useState, useEffect, useContext } from "react";
import Grid from "@material-ui/core/Grid";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { List, ListItem, ListItemText } from "@material-ui/core";
import HelmetMetaData from "../../sharedComponents/SocialMedia/HelmetMetaDeta";
import AppDataContext from "../../common/AppContext";
import AppConstants from "../../common/AppConstants";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    background: "rgba(0, 0, 0, .65) !important",
    padding: theme.spacing(1.5),
    paddingLeft: "18px",
    borderRadius: theme.spacing(1.25),
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(1),
    color: "white",
  },
  textColor: {
    color: "#888888",
  },
  headerText: {
    color: "#fff",
    fontFamily: theme.palette.headerText.fontFamily,
    fontSize: theme.palette.headerText.fontSize,
    fontWeight: "300",
    lineHeight: "1",
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.palette.headerText.mobileHeaderText,
  },
  },
  headerContainer: {
    color: "#ffffff !important",
    marginTop: theme.spacing(3.5),
    marginBottom: theme.spacing(3.5),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(0, 3.5),
    },
  },
  MuiListPadding: {
    paddingTop: "8px",
    paddingBottom: "8px",
    paddingLeft: "6px",
  },
}));

const Aboutus = (props) => {
  const classes = useStyles();
  const { leagueName } = useContext(AppDataContext);
 
  useEffect(() => {
    window.scrollTo(0, 0);
    props.changeTabInHeader("about");
  });
  const HeaderText = (props) => {
    const classes = useStyles();
    return (
      <Grid item xs={12} className={classes.headerContainer}>
        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography
            variant="h4"
            component="h4"
            className={classes.headerText}
          >
            <span>{props.text}</span>
          </Typography>
        </Box>
      </Grid>
    );
  };

  // League-specific content map
  const leagueContent = {
    NBA: {
      about: (
        <>
          NBA LockerVision provides a look into the locker room of every NBA
          team, for every game and every player. It is the premier destination
          for NBA uniform schedules, design details, and on-court collections.
          What started out as an internal NBA scheduling platform, now provides
          fans with access to the most detailed information about what their
          favorite team is wearing on the court each night.
        </>
      ),
      faqs: (
        <>
          <ListItemText>
            <h3>How many uniforms does each NBA team have?</h3>
          </ListItemText>
          <ListItemText>
            NBA Teams can have up to five (5) uniforms per season. These
            uniforms are called Editions. Association Edition, Icon Edition, and
            Statement Edition are known as Core Uniforms and are each on-court
            for multiple seasons. City Edition can change every year and is the
            4th uniform in every team’s lineup. Classic Edition is worn by teams
            commemorating anniversaries or key moments in franchise history.
          </ListItemText>

          <br />

          <ListItemText>
            <h3>Why don’t NBA teams wear white uniforms at Home?</h3>
          </ListItemText>
          <ListItemText>
            NBA uniforms are chosen on a home-team-decides basis. Teams use the
            NBA LockerVision platform to make their uniform selections for all
            Home games and the Road team then uses the NBA LockerVision platform
            to select a uniform that color-contrasts with the home team’s
            choice.
          </ListItemText>

          <br />

          <ListItemText>
            <h3>
              Why are some City Edition uniforms different colors than the
              team’s primary colors?
            </h3>
          </ListItemText>
          <ListItemText>
            The City Edition uniform category allows Teams the color freedom to
            tell hyper-local stories in authentic ways. Teams can use any color
            to bring their City Edition theme to life, while still incorporating
            Team branding in other ways.
          </ListItemText>

          <br />

          <ListItemText>
            <h3>Why are some NBA uniforms Jordan branded?</h3>
          </ListItemText>
          <ListItemText>
            All Statement Edition uniforms are Jordan branded, while the other
            Editions are Nike branded. Statement Edition represents the
            player-mindset and the Jordan Brand reflects that in a unique way.
            The Charlotte Hornets Editions are all Jordan Brand.
          </ListItemText>
        </>
      ),
    },

    WNBA: {
      about: (
        <>
          WNBA LockerVision provides a look into the locker room of every WNBA
          team, for every game and every player. It is the premier destination
          for WNBA uniform schedules, design details, and on-court collections.
          What started out as an internal WNBA scheduling platform, now provides
          fans with access to the most detailed information about what their
          favorite team is wearing on the court each night.
        </>
      ),
      faqs: (
        <>
          <ListItemText>
            <h3>How many uniforms does each WNBA team have?</h3>
          </ListItemText>
          <ListItemText>
            WNBA Teams can have up to four (4) uniforms per season. These
            uniforms are called Editions. Heroine Edition, Explorer Edition, and
            Rebel Edition (HER) are worn by all teams each season. Heroine and
            Explorer Editions are known as Core Uniforms and are each on-court
            for multiple seasons. Rebel Edition changes occur on a different
            cadence and is the 3rd uniform in every team’s lineup. Court Origins
            is worn by teams commemorating anniversaries or key moments in
            franchise history.
          </ListItemText>

          <br />

          <ListItemText>
            <h3>Why don’t WNBA teams wear white uniforms at Home?</h3>
          </ListItemText>
          <ListItemText>
            WNBA uniforms are chosen on a home-team-decides basis. Teams use the
            WNBA LockerVision platform to make their uniform selections for all
            Home games and the Road team then uses the WNBA LockerVision
            platform to select a uniform that color-contrasts with the home
            team’s choice.
          </ListItemText>

          <br />

          <ListItemText>
            <h3>
              Why are Rebel Edition uniforms different than Core uniforms?
            </h3>
          </ListItemText>
          <ListItemText>
            Rebel Edition uniforms allow our WNBA teams and athletes to advance
            women's narratives unapologetically. They can be similar to Core
            uniforms or a further interpretation of a team's brand.
          </ListItemText>
        </>
      ),
    },
  };

  const currentLeagueContent = leagueContent[leagueName];

  return (
    <>
      <HelmetMetaData
        page={AppConstants.PAGES.ABOUTUS}
        url={window.location.href}
        title={`${leagueName} LockerVision - About Us`}
      />
      <Container maxWidth="false">
        <HeaderText text={"About Us"} onClick={() => {}} />
        <Grid container className={classes.mainContainer} spacing={5}>
          <Typography variant="body1" component="p">
            {currentLeagueContent?.about}
          </Typography>
        </Grid>

        <HeaderText text={"FAQs"} onClick={() => {}} />
        <Grid container className={classes.mainContainer} spacing={5}>
          <List>{currentLeagueContent?.faqs}</List>
        </Grid>
      </Container>
    </>
  );
};
export default withRouter(Aboutus);
